import { httpsCallable } from 'firebase/functions';
import type { BusinessOpportunity } from '../types';
import { functions } from './firebase';

const GENERATE_CALLABLE_TIMEOUT_MS = 330_000;

export type GenerateBusinessOpportunityResponse = {
  opportunity: BusinessOpportunity;
};

export function generateBusinessOpportunityErrorMessage(err: unknown): string {
  if (err && typeof err === 'object' && 'message' in err) {
    const message = String((err as { message: string }).message);
    if (message && !message.startsWith('Firebase')) {
      return message;
    }
  }
  if (err && typeof err === 'object' && 'code' in err) {
    const code = String((err as { code: string }).code);
    if (code === 'functions/failed-precondition') {
      return 'Discovery could not find a strong enough idea. Re-index your data in Settings and try again.';
    }
    if (code === 'functions/unauthenticated') {
      return 'Sign in to discover opportunities.';
    }
    if (code === 'functions/unavailable') {
      return 'Discovery service is temporarily unavailable. Try again.';
    }
    if (code === 'functions/deadline-exceeded') {
      return 'Discovery timed out. Try again in a moment.';
    }
    if (code === 'functions/internal') {
      return 'Discovery failed. Try again.';
    }
  }
  return err instanceof Error ? err.message : 'Opportunity discovery failed.';
}

export async function generateBusinessOpportunity(): Promise<BusinessOpportunity> {
  const fn = httpsCallable<void, GenerateBusinessOpportunityResponse>(
    functions,
    'generateBusinessOpportunity',
    { timeout: GENERATE_CALLABLE_TIMEOUT_MS }
  );
  const result = await fn();
  return result.data.opportunity;
}
